import { useState } from "react";
import { saveCredentialK8Pay } from "./api-credential-k8-pay";
import CredentialK8PayForm from "./CredentialK8PayForm";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import { successDefault } from "../../util/ToastUtil";
import SettingsCard from "../Configuracao/SettingsCard";

// As credenciais atuais nunca são exibidas; o formulário começa mascarado.
const MASKED = {
  clientId: "********",
  clientSecret: "********",
  chaveAES: "********",
};

const REQUIRED_FIELDS = [
  ["clientId", "ClientId"],
  ["clientSecret", "ClientSecret"],
  ["chaveAES", "ChaveAES"],
];

const CredentialK8PayContainer = () => {
  const [credentialK8Pay, setCredentialK8Pay] = useState(MASKED);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = () => {
    const vazio = REQUIRED_FIELDS.find(([campo]) => !credentialK8Pay[campo]);
    if (vazio) {
      errorMessage(`Campo ${vazio[1]} não pode ser vazio.`);
      return;
    }

    setIsSaving(true);
    saveCredentialK8Pay(credentialK8Pay)
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(data.message);
          return;
        }
        setCredentialK8Pay(MASKED);
        successDefault();
      })
      .finally(() => setIsSaving(false));
  };

  return (
    <SettingsCard title="Credenciais K8 Pay" description="Integração de pagamentos da instituição.">
      <CredentialK8PayForm
        credentialK8Pay={credentialK8Pay}
        setCredentialK8Pay={setCredentialK8Pay}
        handleSave={handleSave}
        isSaving={isSaving}
      />
    </SettingsCard>
  );
};

export default CredentialK8PayContainer;
